import { render } from "./HomeAvatar.vue?vue&type=template&id=73571a82&scoped=true"
import script from "./HomeAvatar.vue?vue&type=script&lang=js"
export * from "./HomeAvatar.vue?vue&type=script&lang=js"

import "./HomeAvatar.vue?vue&type=style&index=0&id=73571a82&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73571a82"]])

export default __exports__